import { Listing } from './listing.type';

export const getPremiumHighlights = (listing: Listing) => {
    const highlights: string[] = [];

    listing.highlights?.forEach((highlight) => {
        if (highlight?.label) {
            highlights.push(highlight.label);
        }
    });

    return highlights;
};
